import { PatientsAPI } from "../infrastructure/api/patients.api";

export async function listPatientNotes(patientId: string) {
  const { data } = await PatientsAPI.getNotes(patientId);
  return data;
}

export async function listNoteReplies(patientId: string, noteId: string) {
  const { data } = await PatientsAPI.getNoteReplies(patientId, noteId);
  return data;
}

export async function replyToNote(patientId: string, noteId: string, body: string) {
  const { data } = await PatientsAPI.createNoteReply(patientId, noteId, body);
  return data;
}

export async function markNoteRead(patientId: string, noteId: string) {
  const { data } = await PatientsAPI.markNoteRead(patientId, noteId);
  return data;
}
